module.exports = __webpack_public_path__ + "static/media/image_upload.d6b4b778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/image_upload.svg
// module id = 1108
// module chunks = 0